import styled from 'styled-components';

const Form = styled.div`
  .item {
    line-height: 30px;
    &-title {
      margin-right: 20px;
    }

    &-input,
    &-select {
      box-sizing: border-box;
      background: #3f454e;
      height: 32px;
      width: 220px;
      border: none;
      border-radius: 4px;
      padding: 0 12px;
      color: #fff;
    }
    &-select {
      box-sizing: border-box;
      position: relative;
      padding-right: 24px;
      select {
        width: 100%;
        appearance: none;
        background: #3f454e;
        border: none;
      }
      &:after {
        content: '';
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translate(0, -75%) rotate(-45deg);
        width: 6px;
        height: 6px;
        border: solid 1px #b1b3be;
        border-color: transparent transparent #b1b3be #b1b3be;
      }
    }

    &-desc {
      color: #81859b;
      font-size: var(--fs-sm);
      line-height: 1.2;
      padding-top: 8px;
      //transform: scale(0.83333333);
      //transform-origin: left center;
    }
    &-ratio {
      label {
        margin-right: 10px;
      }
      input {
        margin-right: 4px;
        vertical-align: middle;
      }
    }
  }

  .item + .item {
    margin-top: 4px;
  }
`;

export default Form;
